'use client';

const defaultProps = {
  emptyLabel: "No options available"
};
export {
  defaultProps
};
